import { apiRequest } from "./httpClient";

// Admin routes authenticate off the JWT alone (see Backend/utils/tokenOperations.js's
// requireAuth) - unlike every other API module here, no `username` needs to
// be threaded through.
const buildQuery = (params = {}) => {
    const query = Object.entries(params)
        .filter(([, value]) => value !== undefined && value !== null && value !== '')
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');
    return query ? `?${query}` : '';
};

export async function getStats(token) {
    return apiRequest("api/admin/stats", { method: 'GET', token });
}

export async function getUsers(token, { search, page, pageSize, role, banned } = {}) {
    return apiRequest(`api/admin/users${buildQuery({ search, page, pageSize, role, banned })}`, { method: 'GET', token });
}

export async function getUserDetail(token, userId) {
    return apiRequest(`api/admin/users/${userId}`, { method: 'GET', token });
}

export async function banUser(token, userId, reason) {
    return apiRequest(`api/admin/users/${userId}/ban`, { method: 'POST', token, body: { reason } });
}

export async function unbanUser(token, userId) {
    return apiRequest(`api/admin/users/${userId}/unban`, { method: 'POST', token });
}

export async function forceLogoutUser(token, userId) {
    return apiRequest(`api/admin/users/${userId}/force-logout`, { method: 'POST', token });
}

export async function grantAdmin(token, userId) {
    return apiRequest(`api/admin/users/${userId}/grant-admin`, { method: 'POST', token });
}

export async function revokeAdmin(token, userId) {
    return apiRequest(`api/admin/users/${userId}/revoke-admin`, { method: 'POST', token });
}

export async function getOnlineUsers(token) {
    return apiRequest("api/admin/online-users", { method: 'GET', token });
}

export async function sendAnnouncement(token, message) {
    return apiRequest("api/admin/announcement", { method: 'POST', token, body: { message } });
}

export async function getSettings(token) {
    return apiRequest("api/admin/settings", { method: 'GET', token });
}

export async function updateSettings(token, { registrationOpen, registrationClosedMessage }) {
    return apiRequest("api/admin/settings", { method: 'PATCH', token, body: { registrationOpen, registrationClosedMessage } });
}

export async function getAuditLog(token, { page, pageSize, action, targetUserId } = {}) {
    return apiRequest(`api/admin/audit-log${buildQuery({ page, pageSize, action, targetUserId })}`, { method: 'GET', token });
}

// parts: any of 'avatar', 'banner', 'text'.
export async function resetProfile(token, userId, parts) {
    return apiRequest(`api/admin/users/${userId}/reset-profile`, { method: 'POST', token, body: { parts } });
}
